export default {
    apiUrl: process.env.VUE_APP_API_URL,
    apiToken: process.env.VUE_APP_API_TOKEN,
    helpdeskUrl: process.env.VUE_APP_HELPDESK_API_URL,
    helpdeskLimit: 250,
    yandexSmartCaptchaPublicKey: process.env.VUE_APP_YANDEX_SMART_CAPTCHA_SITE_KEY
}